import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddPromotionPageNew from "../../components/Promotion/AddPromotionPageNew";



const AddPromotionPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Promotion" link2="/promotion" title="Add Promotion" />

        {/* AddUserLayer */}
        <AddPromotionPageNew />


      </MasterLayout>
    </>
  );
};

export default AddPromotionPage;
